/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function MemberGridController(this: JS5Object, uiGridConstants: JS5Object) {
    this.validationType = {displayName: 'Not Applicable', id: 'NOT_APPLICABLE'};
    this.$onInit = () => {
        this.members = _.get(_.get(this, 'availableMembers'), _.get(this, 'mediaAcceptProfileType'));
        this.gridOptions.data = _.toArray(_.get(this, 'mediaAcceptProfiles'));
        if (this.mediaAcceptProfileType === 'VIDEO') {
            this.validationType = _.find(this.availableValidationTypes, {'id': 'REQUIRED'});
        } else {
            setValidationType();
        }
    };

    /*
        This sets the drop down upon loading the data
     */
    const setValidationType = () => {
        let applicableMembers = _.filter(_.get(this, 'members'), (member: JS5Object) => {
            return member.validationType !== 'NOT_APPLICABLE';
        });
        this.validationType = _.find(this.availableValidationTypes, {'id': _.get(_.first(applicableMembers), 'validationType', 'NOT_APPLICABLE')});
    };

    /*
        Handles when the validation type drop down changes. Take all the selected rows and set the corresponding
         member's validation type to what's in the drop down. Set all of the members that correspond to the unselected
         rows to 'NOT_APPLICABLE'
     */
    this.onValidationTypeChanged = () => {
        _.forEach(this.members, (member) => {
            let row = _.find(this.gridApi.core.getVisibleRows(this), (row) => {
                return _.isEqual(_.get(row, 'entity.id'), _.get(member, 'acceptProfile.id'));
            });
            _.set(member, 'validationType', _.get(row, 'isSelected') ? this.validationType.id : 'NOT_APPLICABLE');
        });
    };

    /*
        Handles when one row is toggled
     */
    this.onRowSelection = (row) => {
        setMemberValidation(row);
    };

    /*
        Handles when the select all is toggled
     */
    this.onSelectAllRows = (rows: JS5Object[]) => {
        _.forEach(rows, (row) => {
            setMemberValidation(row);
        });
    };

    /*
        For a single row, take its checked state and the selected validation type in the validation type drop down and
         look up its member and set the validation type to whats in the drop down.

        If the row is being deselected, set the validation type to 'NOT_APPLICABLE'
    */
    const setMemberValidation = (row: JS5Object) => {
        let matchedMember = _.find(this.members, (member) => {
            return _.isEqual(_.get(row, 'entity.id'), _.get(member, 'acceptProfile.id'));
        });
        if (_.isNil(matchedMember)) {
            this.members.push({
                validationType: this.validationType.id,
                acceptProfile: row.entity
            });
        }
        _.set(matchedMember, 'validationType', _.get(row, 'isSelected') ? _.get(this, 'validationType.id') : 'NOT_APPLICABLE');
        this.editorForm.$setDirty();
    };

    /*
        This handles setting the checkbox state for each row upon loading the data. It takes the row's entity and looks
         up the validation state in the members collection and sets the checkbox if it's found and the validation type
         is not'NOT_APPLICABLE'
     */
    this.processGridFilter = (renderableRows: JS5Object) => {
        renderableRows.forEach((row: JS5Object) => {
            let matchedAcceptProfile = _.find(this.members, (member) => {
                return _.isEqual(_.get(row, 'entity.id'), _.get(member, 'acceptProfile.id'))
                    && _.isEqual(_.get(member, 'validationType'), _.get(this, 'validationType.id'));
            });
            if (!_.isNil(matchedAcceptProfile) && row && _.get(this, 'validationType.id') !== 'NOT_APPLICABLE') {
                row.setSelected(true);
            } else if (row) {
                row.setSelected(false);
            }
        });
        return renderableRows;
    };
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: true,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        multiSelect: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        columnDefs: [
            {
                field: 'name',
                displayName: 'Media Profile Name',
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                sort: {
                    direction: 'asc',
                    priority: 0
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }
        ],
        data: [],
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
            this.gridApi.grid.registerRowsProcessor(this.processGridFilter, 200);
            gridApi.selection.on.rowSelectionChanged(null, this.onRowSelection);
            gridApi.selection.on.rowSelectionChangedBatch(null, this.onSelectAllRows);

        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
}

angular.module('prism-ui.content').component('memberGrid', {
    templateUrl: 'meta/content/editor/components/view/packageAcceptTemplates/content-package-accept-templates-member-view-component/member-grid-component/member-grid-template.html',
    controller: MemberGridController,
    bindings: {
        mediaAcceptProfiles: '<',
        mediaAcceptProfileType: '<',
        availableValidationTypes: '<',
        availableMembers: '<'
    }
});
